module.exports = "/_next/static/images/fee_optimization_mobile-5e13bd4bb0d0435d3005db0e9b707530.jpg";